import { BRIDGE_AGETH_OPTIONS, BRIDGE_OPTIONS } from "@constants/common";
import useDappConfig from "./useDappConfig";
import { AGETH, RSETH, WAGETH, WRSETH } from "@config/contractsConfig";
import { BW_VARIANT, TBW_VARIANT } from "@components/BridgeWrapV2/types";
import { arbitrum, mainnet } from "viem/chains";
import { DEPRECATED_BRIDGE_CHAIN_IDS } from "@constants/chains";

const useBridgeWrapConfig = (variant: TBW_VARIANT) => {
  const { swapEnabledChains, vaultSwapEnabledChains } = useDappConfig();
  // const { vaultEnabledChains } = useDappConfig();
  const isAgETH = variant === BW_VARIANT.AGETH;
  const filteredChains = isAgETH
    ? [mainnet, ...vaultSwapEnabledChains]
    : [mainnet, arbitrum, ...swapEnabledChains].filter(
        (chain) => !DEPRECATED_BRIDGE_CHAIN_IDS.has(chain.id)
      );
  const config = {
    assets: [
      { id: RSETH, title: RSETH },
      { id: WRSETH, title: WRSETH },
      { id: WAGETH, title: WAGETH },
      { id: AGETH, title: AGETH },
    ],
    sourceChains: Object.values([...filteredChains]).map((chain) => {
      if (chain.name.toLowerCase().includes("manta")) {
        return {
          id: chain.id,
          title: chain.name.split(" ").slice(0, 2).join(" "),
        };
      }
      return { id: chain.id, title: chain.name };
    }),
    destinationChains: Object.values([...filteredChains]).map((chain) => {
      if (chain.name.toLowerCase().includes("manta")) {
        return {
          id: chain.id,
          title: chain.name.split(" ").slice(0, 2).join(" "),
        };
      }
      return { id: chain.id, title: chain.name };
    }),
    bridgeChains: isAgETH ? BRIDGE_AGETH_OPTIONS : BRIDGE_OPTIONS,
  };

  return {
    ...config,
  };
};

export default useBridgeWrapConfig;
